import { Button, Divider, Drawer, Form, Input, Radio } from "antd";
import React from "react";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { colors } from "../../../../../Utils/temas";
const { Item, useForm } = Form;
const { Group } = Radio;

export const DrawerFilter = ({ visible, onClose, onFinish, limpar }) => {
  const [form] = useForm();

  return (
    <Drawer visible={visible} onClose={onClose} title="Filtros">
      <Form
        form={form}
        layout="vertical"
        style={{ fontWeight: "500", height: "100%" }}
        onFinish={onFinish}
      >
        <Item name="campo_nome" label="Campo:">
          <Input />
        </Item>

        <Item name="em_teste" label="Em teste:" style={{ fontWeight: "500" }}>
          <Group>
            <Radio value={true}>Sim</Radio>
            <Radio value={false}>Não</Radio>
          </Group>
        </Item>

        <div
          style={{
            height: "78%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <Divider />

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              icon={<SearchOutlined />}
              style={{
                background: colors.secondary,
                color: "white",
                fontWeight: "500",
              }}
              htmlType="submit"
            >
              Pesquisar
            </Button>

            <Button
              icon={<ClearOutlined />}
              onClick={() => {
                limpar();
                form.resetFields();
              }}
            >
              Limpar
            </Button>
          </div>
        </div>
      </Form>
    </Drawer>
  );
};
